import { Controller } from "@hotwired/stimulus"

// An Active Storage attachment can outlive the bytes it names. Keep the
// person's identity legible when the image request fails, including when it
// fails before Stimulus connects to an avatar inserted by Turbo.
export default class extends Controller {
  static targets = ["image", "fallback"]

  connect() {
    if (this.imageTarget.complete && !this.imageTarget.naturalWidth) this.failed()
  }

  failed() {
    this.imageTarget.hidden = true
    this.fallbackTarget.hidden = false
  }
}
